// Recorded delegated-document-work receipt bundles for the Spaulding & Oakes
// Overview timeline.
//
// Two REAL sealed execution records produced by
// scripts/generate-legal-receipts.ts (deterministic multi-step gig + in-process
// witness), inlined at build like the other demos' data.ts. Both share one
// agent identity and are four-action chains (drafted → cite-checked → filed →
// docketed), differing only in the filing court (and thus the verdict):
//   filing-conformant — filed N.D. Cal. (on allowlist)  -> conformant: true
//   filing-violation  — filed E.D. Tex. (off allowlist) -> conformant: false
import filingConformant from "../../../demo-artifacts-legal/receipts/filing-conformant/bundle.json";
import filingViolation from "../../../demo-artifacts-legal/receipts/filing-violation/bundle.json";

export type Bundle = Record<string, string>;

// Keyed by the bundleId each timeline scenario references.
export const LEGAL_BUNDLES: Record<string, Bundle> = {
  "filing-conformant": filingConformant as Bundle,
  "filing-violation": filingViolation as Bundle
};
